export default __webpack_public_path__ + "static/media/fav2.c981d716.jpg";